(() => {
  if (customElements.get('jadyk-launch-countdown')) return;

  class JadyKLaunchCountdown extends HTMLElement {
    constructor() {
      super();
      this.tick = this.tick.bind(this);
    }

    connectedCallback() {
      this.deadline = Date.parse(this.dataset.launchAt);
      this.clock = this.querySelector('[data-clock]');
      this.ended = this.querySelector('[data-ended]');
      this.linkText = this.querySelector('[data-link-text]');
      this.comingSoon = this.querySelector('[data-coming-soon]');
      this.launchLink = this.querySelector('[data-launch-link]');
      this.units = ['days', 'hours', 'minutes', 'seconds'].map(unit => this.querySelector(`[data-unit="${unit}"]`));
      if (!Number.isFinite(this.deadline) || !this.clock || !this.ended || this.units.some(unit => !unit)) {
        if (this.clock) this.clock.hidden = true;
        return;
      }
      if (this.tick()) {
        this.interval = window.setInterval(this.tick, 1000);
        document.addEventListener('visibilitychange', this.tick);
      }
    }

    tick() {
      const total = Math.max(0, Math.ceil((this.deadline - Date.now()) / 1000));
      if (total === 0) {
        this.clock.hidden = true;
        this.ended.hidden = false;
        if (this.ended.textContent !== this.dataset.endedText) this.ended.textContent = this.dataset.endedText;
        if (this.linkText) this.linkText.textContent = this.dataset.endedLink;
        if (this.comingSoon) this.comingSoon.hidden = true;
        if (this.launchLink) this.launchLink.hidden = false;
        this.disconnectedCallback();
        return false;
      }
      const values = [Math.floor(total / 86400), Math.floor(total % 86400 / 3600), Math.floor(total % 3600 / 60), total % 60];
      values.forEach((value, index) => {
        const text = String(value).padStart(2, '0');
        if (this.units[index].textContent !== text) this.units[index].textContent = text;
      });
      return true;
    }

    disconnectedCallback() {
      window.clearInterval(this.interval);
      document.removeEventListener('visibilitychange', this.tick);
    }
  }

  customElements.define('jadyk-launch-countdown', JadyKLaunchCountdown);
})();
